import { jsxs as r, jsx as C } from "react/jsx-runtime";
const t = ({ className: l, width: e = "18", height: o = "18" }) => /* @__PURE__ */ r(
  "svg",
  {
    className: l,
    width: e,
    height: o,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    fill: "none",
    children: [
      /* @__PURE__ */ C("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.125 3.375C0.826633 3.375 0.540482 3.49353 0.329505 3.7045C0.118529 3.91548 0 4.20163 0 4.5V14.0625C0 14.3608 0.118452 14.6469 0.329434 14.8579C0.540461 15.069 0.826661 15.1875 1.125 15.1875H11.25C11.5607 15.1875 11.8125 14.9357 11.8125 14.625C11.8125 14.3143 11.5607 14.0625 11.25 14.0625L1.125 14.0625L1.125 4.5L4.875 4.5L6.825 5.9625C7.01975 6.10858 7.25661 6.1875 7.5 6.1875L13.5 6.18752V7.3125C13.5 7.62316 13.7518 7.875 14.0625 7.875C14.3732 7.875 14.625 7.62316 14.625 7.3125V6.1875C14.625 5.88923 14.5066 5.60309 14.2955 5.39208C14.0845 5.181 13.7983 5.0625 13.5 5.0625H7.5L5.55 3.6C5.35526 3.45394 5.11841 3.375 4.875 3.375H1.125Z", fill: "currentColor" }),
      /* @__PURE__ */ C("path", { d: "M14.0625 8.625C14.3732 8.625 14.625 8.87684 14.625 9.1875V11.25H16.6875C16.9982 11.25 17.25 11.5018 17.25 11.8125C17.25 12.1232 16.9982 12.375 16.6875 12.375H14.625V14.4375C14.625 14.7482 14.3732 15 14.0625 15C13.7518 15 13.5 14.7482 13.5 14.4375V12.375H11.4375C11.1268 12.375 10.875 12.1232 10.875 11.8125C10.875 11.5018 11.1268 11.25 11.4375 11.25H13.5V9.1875C13.5 8.87684 13.7518 8.625 14.0625 8.625Z", fill: "currentColor" })
    ]
  }
);
export {
  t as default
};
